var React = require('react');

function ArrowLong (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 61.6853L1.44643 60.0092L14.9643 75.5023V-0.000976562L17.0357 -0.000976562V75.5023L30.5536 60.0092L32 61.6853L16 79.999L0 61.6853Z","fill":"white"}));
}

ArrowLong.defaultProps = {"width":"32","height":"80","viewBox":"0 0 32 80","fill":"none"};

module.exports = ArrowLong;

ArrowLong.default = ArrowLong;
